import React, { Component } from 'react';


class ClusterMarker extends Component {
    constructor(props) {
        super(props);
    }
    updateMap() {
        this.props.onClickCluster();
    }
    render() {
        
        let zIndex = this.props.quantity * 10;
        const style = { zIndex: zIndex };
        return (
                <div className="cluster-marker" style={style} onClick={this.updateMap.bind(this)}><span className="cluster-quantity" >{this.props.quantity}</span>
            </div>
        )
    }
}

export default ClusterMarker;
